import React from 'react';
import { useMsal } from '@azure/msal-react';
import config from '../../config/config';
import './Login.css';

// Renders a button which, when selected, will redirect the page to the login prompt
const SignInButton = () => {
  const { instance } = useMsal();

  async function handleLogin(instance) {
    await instance.loginRedirect(config.loginRequest).catch((e) => {
      console.error(e);
    });
  }

  return (
    <button className='sign-in-btn' onClick={() => handleLogin(instance)}>
      Sign in
    </button>
  );
};

export default SignInButton;
